export default "__VITE_ASSET__BpNti35J__"